/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recent_LeadsInputs */

const cs_dashboard_recent_leads = /** @type {(inputs: Dashboard_Recent_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávné leady`)
};

const en_dashboard_recent_leads = /** @type {(inputs: Dashboard_Recent_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent leads`)
};

/**
* | output |
* | --- |
* | "Recent leads" |
*
* @param {Dashboard_Recent_LeadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_recent_leads = /** @type {((inputs?: Dashboard_Recent_LeadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recent_LeadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_recent_leads(inputs)
	return cs_dashboard_recent_leads(inputs)
});